enum AddressUnitDesignator {
	None = 0,
	Apartment = 1,
	Basement = 2,
	Building = 3,
	Department = 4,
	Floor = 5,
	Front = 6,
	Hanger = 7,
	Key = 8,
	Lobby = 9,
	Lot = 10,
	Lower = 11,
	Office = 12,
	Penthouse = 13,
	Pier = 14,
	Rear = 15,
	Room = 16,
	Side = 17,
	Slip = 18,
	Space = 19,
	Stop = 20,
	Suite = 21,
	Trailer = 22,
	Unit = 23,
	Upper = 24
}

export default AddressUnitDesignator;
